import { HTTP_METHODS } from '@studio/constants/axios';
import { CENTRAL_API_V1 } from '@studio/constants/env-variables';
import type { Hardware } from '@studio/types';

export const root = {
  [HTTP_METHODS.GET]: {
    method: HTTP_METHODS.GET,
    response: [] as Hardware.Get.HardwareModel[],
    url: `${CENTRAL_API_V1}/hardwaremodels`,
  },
  [HTTP_METHODS.POST]: {
    url: `${CENTRAL_API_V1}/hardwaremodels`,
    request: {} as Hardware.Post.HardwareModel,
    method: HTTP_METHODS.POST,
  },
};

export const id = {
  [HTTP_METHODS.PATCH]: {
    method: HTTP_METHODS.PATCH,
    params: {} as { id: string },
    request: {} as Hardware.Patch.V1.HardwareModel,
    url: `${CENTRAL_API_V1}/hardwaremodels/@id`,
  },
  [HTTP_METHODS.DELETE]: {
    method: HTTP_METHODS.DELETE,
    params: {} as { id: string },
    url: `${CENTRAL_API_V1}/hardwaremodels/@id`,
  },
};
